import { Component} from '@angular/core';

@Component({
    selector: 'app-aitoken',
    templateUrl: './aitoken.component.html',
    styleUrls: ['./aitoken.component.scss'],
    standalone: false
})
export class AitokenComponent  {



}


